<app-home [titre]="title" [menu]="menu" [darkTheme]="true" [miniSidenav]="true" [open]="false" [avatar]="false"></app-home>
